unit View.Promocoes.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, System.StrUtils, UUtils,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela;

type
  TFViewPromocoesList = class(TForm)
    btNew: TButton;
    PromocoesDataset: TXDataWebDataSet;
    PromocoesDatasetid: TIntegerField;
    PromocoesDatasetnome: TStringField;
    PromocoesDatasetdata_inicio: TDateTimeField;
    PromocoesDatasetdata_fim: TDateTimeField;
    PromocoesDatasetstatus: TIntegerField;
    PromocoesDatasetexcluido: TBooleanField;
    PromocoesDatasetinclusao: TDateTimeField;
    PromocoesDatasetalteracao: TDateTimeField;
    PromocoesDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    PromocoesDatasetaliadoNome_Fantasia: TXDataWebDatasetField;
    PromocoesDatasetfuncionarionome: TXDataWebDatasetField;
    cbbPromocaoStatus: TComboBox;
    tmrConsulta: TTimer;
    PromocoesDatasetcodigo_interno: TIntegerField;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure cbbPromocaoStatusChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewPromocoesList: TFViewPromocoesList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPromocoesList }

procedure TFViewPromocoesList.cbbPromocaoStatusChange(Sender: TObject);
var
  lFiltro : string;
begin
  case cbbPromocaoStatus.ItemIndex of
    0 : lFiltro := '';
    else lFiltro := 'status eq ' + cbbPromocaoStatus.ItemIndex.ToString;
  end;

  edSearch.Text := EmptyStr;
  cbPageSize.ItemIndex := 0;

  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.FDatasetPlugin.FFilterPadrao := lFiltro;
  FGridPlugin.Load;
end;

procedure TFViewPromocoesList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewPromocoesList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPromocoesList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewPromocoesList, AElementID, Result, @AfterCreate);
end;

procedure TFViewPromocoesList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewPromocoesList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewPromocoesList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewPromocoesList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewPromocoesList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      PromocoesDataset.Connection.Model.DefaultSchema.FindEntityType(PromocoesDataset.EntitySetName),
      PromocoesDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Ver dados');
    Button.ElementHandle.setAttribute('data-test', 'btn_ver_promocao');
  end;
end;

procedure TFViewPromocoesList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['aliado.Nome_Fantasia',
      'nome', 'funcionario.nome']) of
      0, 1, 2: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewPromocoesList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido', 'status']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      1:
      begin
        case StrToInt(AValue) of
          1 : AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Iniciada</div>';
          2 : AValue := '<div class="rounded-pill" style="background-color: #FCFEBE;color:black; padding-right: 5px;padding-left: 5px;">Agendada</div>';
          3 : AValue := '<div class="rounded-pill" style="background-color: #FFB5F1;color:black; padding-right: 5px;padding-left: 5px;">Em criação</div>';
          else  AValue := '<div class="rounded-pill" style="background-color: #FFAAAA;color:black; padding-right: 5px;padding-left: 5px;">Encerrada</div>';
        end;
      end;
      else
      begin
        if UpperCase(AValue) = 'NULL' then
          AValue := '';
      end;
    end;
  end;
end;

procedure TFViewPromocoesList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('promocoes', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, PromocoesDataset,
    lcPaginator, lbPaginationInfo);

  cbbPromocaoStatus.ItemIndex := 1;
  FGridPlugin.FDatasetPlugin.FFilterPadrao := 'status eq 1';

  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewPromocoesList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.promocoes.list.pagination.info');
  btNew := TButton.Create('view.promocoes.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.promocoes.list.table');
  cbPageSize := TComboBox.Create('view.promocoes.list.cbPageSize');
  edSearch := TEdit.Create('view.promocoes.list.search');
  lcPaginator := TListControl.Create('view.promocoes.list.pagination');
  cbbPromocaoStatus := TComboBox.Create('cbbPromocaoStatus');
  PromocoesDataset := TXDataWebDataSet.Create(Self);
  PromocoesDatasetid := TIntegerField.Create(Self);
  PromocoesDatasetnome := TStringField.Create(Self);
  PromocoesDatasetdata_inicio := TDateTimeField.Create(Self);
  PromocoesDatasetdata_fim := TDateTimeField.Create(Self);
  PromocoesDatasetstatus := TIntegerField.Create(Self);
  PromocoesDatasetexcluido := TBooleanField.Create(Self);
  PromocoesDatasetinclusao := TDateTimeField.Create(Self);
  PromocoesDatasetalteracao := TDateTimeField.Create(Self);
  PromocoesDatasetexclusao := TDateTimeField.Create(Self);
  PromocoesDatasetaliadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  PromocoesDatasetfuncionarionome := TXDataWebDatasetField.Create(Self);
  PromocoesDatasetcodigo_interno := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  cbbPromocaoStatus.BeforeLoadDFMValues;
  PromocoesDataset.BeforeLoadDFMValues;
  PromocoesDatasetid.BeforeLoadDFMValues;
  PromocoesDatasetnome.BeforeLoadDFMValues;
  PromocoesDatasetdata_inicio.BeforeLoadDFMValues;
  PromocoesDatasetdata_fim.BeforeLoadDFMValues;
  PromocoesDatasetstatus.BeforeLoadDFMValues;
  PromocoesDatasetexcluido.BeforeLoadDFMValues;
  PromocoesDatasetinclusao.BeforeLoadDFMValues;
  PromocoesDatasetalteracao.BeforeLoadDFMValues;
  PromocoesDatasetexclusao.BeforeLoadDFMValues;
  PromocoesDatasetaliadoNome_Fantasia.BeforeLoadDFMValues;
  PromocoesDatasetfuncionarionome.BeforeLoadDFMValues;
  PromocoesDatasetcodigo_interno.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewPromocoesList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Promo'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario.nome';
      Title := 'Funcion'#225'rio';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_inicio';
      Title := 'Data In'#237'cio';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_fim';
      Title := 'Data Fim';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    cbbPromocaoStatus.SetParentComponent(Self);
    cbbPromocaoStatus.Name := 'cbbPromocaoStatus';
    cbbPromocaoStatus.Left := 288;
    cbbPromocaoStatus.Top := 416;
    cbbPromocaoStatus.Width := 145;
    cbbPromocaoStatus.Height := 21;
    cbbPromocaoStatus.HeightPercent := 100.000000000000000000;
    cbbPromocaoStatus.TabStop := False;
    cbbPromocaoStatus.Text := 'TODAS';
    cbbPromocaoStatus.WidthPercent := 100.000000000000000000;
    SetEvent(cbbPromocaoStatus, Self, 'OnChange', 'cbbPromocaoStatusChange');
    cbbPromocaoStatus.ItemIndex := 0;
    cbbPromocaoStatus.Items.BeginUpdate;
    try
      cbbPromocaoStatus.Items.Clear;
      cbbPromocaoStatus.Items.Add('TODAS');
      cbbPromocaoStatus.Items.Add('INICIADA');
      cbbPromocaoStatus.Items.Add('AGENDADA');
      cbbPromocaoStatus.Items.Add('EM CRIA'#199#195'O');
      cbbPromocaoStatus.Items.Add('ENCERRADA');
    finally
      cbbPromocaoStatus.Items.EndUpdate;
    end;
    PromocoesDataset.SetParentComponent(Self);
    PromocoesDataset.Name := 'PromocoesDataset';
    PromocoesDataset.EntitySetName := 'Promocoes';
    PromocoesDataset.Connection := DMConnection.ApiConnection;
    PromocoesDataset.Left := 72;
    PromocoesDataset.Top := 144;
    PromocoesDatasetid.SetParentComponent(PromocoesDataset);
    PromocoesDatasetid.Name := 'PromocoesDatasetid';
    PromocoesDatasetid.FieldName := 'id';
    PromocoesDatasetid.Required := True;
    PromocoesDatasetnome.SetParentComponent(PromocoesDataset);
    PromocoesDatasetnome.Name := 'PromocoesDatasetnome';
    PromocoesDatasetnome.FieldName := 'nome';
    PromocoesDatasetnome.Size := 255;
    PromocoesDatasetdata_inicio.SetParentComponent(PromocoesDataset);
    PromocoesDatasetdata_inicio.Name := 'PromocoesDatasetdata_inicio';
    PromocoesDatasetdata_inicio.FieldName := 'data_inicio';
    PromocoesDatasetdata_inicio.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetdata_fim.SetParentComponent(PromocoesDataset);
    PromocoesDatasetdata_fim.Name := 'PromocoesDatasetdata_fim';
    PromocoesDatasetdata_fim.FieldName := 'data_fim';
    PromocoesDatasetdata_fim.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetstatus.SetParentComponent(PromocoesDataset);
    PromocoesDatasetstatus.Name := 'PromocoesDatasetstatus';
    PromocoesDatasetstatus.FieldName := 'status';
    PromocoesDatasetexcluido.SetParentComponent(PromocoesDataset);
    PromocoesDatasetexcluido.Name := 'PromocoesDatasetexcluido';
    PromocoesDatasetexcluido.FieldName := 'excluido';
    PromocoesDatasetinclusao.SetParentComponent(PromocoesDataset);
    PromocoesDatasetinclusao.Name := 'PromocoesDatasetinclusao';
    PromocoesDatasetinclusao.FieldName := 'inclusao';
    PromocoesDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetalteracao.SetParentComponent(PromocoesDataset);
    PromocoesDatasetalteracao.Name := 'PromocoesDatasetalteracao';
    PromocoesDatasetalteracao.FieldName := 'alteracao';
    PromocoesDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetexclusao.SetParentComponent(PromocoesDataset);
    PromocoesDatasetexclusao.Name := 'PromocoesDatasetexclusao';
    PromocoesDatasetexclusao.FieldName := 'exclusao';
    PromocoesDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    PromocoesDatasetaliadoNome_Fantasia.SetParentComponent(PromocoesDataset);
    PromocoesDatasetaliadoNome_Fantasia.Name := 'PromocoesDatasetaliadoNome_Fantasia';
    PromocoesDatasetaliadoNome_Fantasia.FieldKind := fkCalculated;
    PromocoesDatasetaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    PromocoesDatasetaliadoNome_Fantasia.Calculated := True;
    PromocoesDatasetfuncionarionome.SetParentComponent(PromocoesDataset);
    PromocoesDatasetfuncionarionome.Name := 'PromocoesDatasetfuncionarionome';
    PromocoesDatasetfuncionarionome.FieldKind := fkCalculated;
    PromocoesDatasetfuncionarionome.FieldName := 'funcionario.nome';
    PromocoesDatasetfuncionarionome.Calculated := True;
    PromocoesDatasetcodigo_interno.SetParentComponent(PromocoesDataset);
    PromocoesDatasetcodigo_interno.Name := 'PromocoesDatasetcodigo_interno';
    PromocoesDatasetcodigo_interno.FieldName := 'codigo_interno';
    PromocoesDatasetcodigo_interno.Required := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := PromocoesDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    cbbPromocaoStatus.AfterLoadDFMValues;
    PromocoesDataset.AfterLoadDFMValues;
    PromocoesDatasetid.AfterLoadDFMValues;
    PromocoesDatasetnome.AfterLoadDFMValues;
    PromocoesDatasetdata_inicio.AfterLoadDFMValues;
    PromocoesDatasetdata_fim.AfterLoadDFMValues;
    PromocoesDatasetstatus.AfterLoadDFMValues;
    PromocoesDatasetexcluido.AfterLoadDFMValues;
    PromocoesDatasetinclusao.AfterLoadDFMValues;
    PromocoesDatasetalteracao.AfterLoadDFMValues;
    PromocoesDatasetexclusao.AfterLoadDFMValues;
    PromocoesDatasetaliadoNome_Fantasia.AfterLoadDFMValues;
    PromocoesDatasetfuncionarionome.AfterLoadDFMValues;
    PromocoesDatasetcodigo_interno.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
